module.exports = __webpack_public_path__ + "static/carrier-accept-orders-17eb08a54844ab8935454279f02b26eb.png";